export enum IdvChannel {
  REFERRAL = 'referral',
  NON_REFERRAL = 'non-referral',
}
